import { FC } from 'react'
import { useRouter } from 'next/router'

import OriginLink from 'components/parts/originLink/originLink'

import { generateDateTimeFromSec } from 'utils/formatDate'
import { generateTumbnail } from 'utils/generatePreview'
import { getDigitFromString } from 'utils/getURLData'
import { IMaterialCard } from 'constants/types/card.types'
import { getBaseUrl } from './utils'

import styles from './playlist-card.module.scss'

interface IPlaylistCard extends IMaterialCard {
  index: number
  originWebinar: string | string[] | undefined
}

const PlaylistCard: FC<IPlaylistCard> = (props) => {
  const { index, name, duration, linkTranslation, id, videoLink, originWebinar, materialType } =
    props
  const durationVideo = duration ? generateDateTimeFromSec(Number(duration)) : '0:00:00'
  const preview = generateTumbnail(videoLink as string)
  const router = useRouter()
  const { query } = router
  const { id: idFromQuery } = query
  const isActiveVideo = getDigitFromString(idFromQuery as string) === String(id)
  const baseURLLink = getBaseUrl(materialType)

  return (
    <OriginLink
      href={`/${baseURLLink}/${linkTranslation || id}?dopId=${originWebinar}`}
      origin={'playlist'}
    >
      <div className={styles.videoCard} style={{ background: isActiveVideo ? '#E8F8FF' : 'none' }}>
        <p className={styles.videoNum}>{index + 1}</p>
        <div className={styles.videoPreview} style={{ backgroundImage: `url(${preview})` }}>
          <p className={styles.videoDuration}>{durationVideo}</p>
        </div>
        <p className={styles.videoTitle}>{name}</p>
      </div>
    </OriginLink>
  )
}

export default PlaylistCard
